import React, { useState, useEffect } from 'react';
import { useConsent } from '../../contexts/ConsentContext';
import { getGlid, getAk, getMobile, getQueryParamUtils, gatrack } from '../../utils';
import { useStatutoryDetails } from '../../contexts/StatutoryDetailsContext';
import '../../CssFiles/consentModal.css';

function ClipboardIllustration() {
  return (
    <svg
      className="consent-illustration"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="#EBF8F6" />
      {/* Clipboard body */}
      <rect x="28" y="30" width="36" height="44" rx="4" fill="#fff" stroke="#46968e" strokeWidth="2" />
      {/* Clipboard top */}
      <rect x="38" y="26" width="16" height="8" rx="3" fill="#46968e" />
      {/* Check lines */}
      <line x1="35" y1="45" x2="55" y2="45" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" />
      <line x1="35" y1="52" x2="55" y2="52" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" />
      <line x1="35" y1="59" x2="48" y2="59" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round" />
      {/* Checkmark */}
      <circle cx="67" cy="68" r="12" fill="#46968e" />
      <polyline points="61,68 65,72 73,63" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function ConsentModal() {
  const { showConsentModal, submitConsent } = useConsent();
  const { statutoryDetails } = useStatutoryDetails();
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);

  // Fire a GA tag whenever the recapture consent popup becomes visible
  useEffect(() => {
    if (showConsentModal) {
      gatrack(
        "HT Journey",
        "Consent Popup Shown",
        "Recapture Consent Modal",
        getGlid(),
        null,
        JSON.stringify(Object.fromEntries(getQueryParamUtils()))
      );
    }
  }, [showConsentModal]);

  if (!showConsentModal) return null;

  const handleContinue = async () => {
    if (!checked || loading) return;
    setLoading(true);

    const glid = getGlid();
    const ak = getAk();

    gatrack(
      "HT Journey",
      "Consent Clicked",
      "Recapture Consent Modal",
      glid,
      null,
      JSON.stringify(Object.fromEntries(getQueryParamUtils()))
    );

    await submitConsent({
      glid,
      ak,
    });

    setLoading(false);
  };

  return (
    <div className="consent-overlay">
      <div className="consent-modal" role="dialog" aria-modal="true" aria-labelledby="consent-title">
        <ClipboardIllustration />

        <h2 className="consent-title" id="consent-title">One quick step to continue</h2>
        <p className="consent-subtitle">
          We need your updated consent to fetch the latest credit details and keep your progress saved.
        </p>

        <div className="consent-checkbox-row">
          <input
            type="checkbox"
            id="consent-check"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <label className="consent-checkbox-label" htmlFor="consent-check">
            By proceeding, I agree to provide personal details and authorise Hello Trade to obtain
            my Credit Information from bureau partners&nbsp;(
            <a href="https://www.hellotrade.com/terms-and-conditions#experian" target="_blank" rel="noopener noreferrer">
              Experian T&amp;C
            </a>
            ). I also agree to Hello Trade{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
              T&amp;Cs
            </a>
            .
          </label>
        </div>

        <button
          className="consent-btn"
          onClick={handleContinue}
          disabled={!checked || loading}
        >
          {loading ? 'Please wait...' : "Let's continue"}
        </button>
      </div>
    </div>
  );
}
